export default {
  ma: [
    'congratulations-ma.mp3',
    'excellent-ma.mp3',
    'gotitright-ma-1.mp3',
    'gotitright-ma-2.mp3',
    'greatjob-ma.mp3',
    'ohyeah-ma.mp3',
    'perfect-ma.mp3',
    'thatsright-ma.mp3',
    'verygood-ma.mp3',
    'wonderful-ma.mp3',
    'yes-ma.mp3',
    'youaresmart-ma.mp3',
    'youdidit-ma.mp3',
    'yougotit-ma.mp3',
    'yourock-ma.mp3',
    'alright-ma.mp3',
    'well-done-ma.mp3',
    'nice-ma.mp3',
    'thats-it-ma.mp3',
    'good-job-ma.mp3',
    'great-ma.mp3',
    'way-to-go-ma.mp3'
  ],
  fa: [
    'congratulations-fa.mp3',
    'excellent-fa.mp3',
    'gotitright-fa.mp3',
    'greatjob-fa.mp3',
    'perfect-fa.mp3',
    'thatsright-fa.mp3',
    'verygood-fa.mp3',
    'wonderful-fa.mp3',
    'yes-fa.mp3',
    'youaresmart-fa.mp3',
    'youdidit-fa.mp3',
    'yougotit-fa.mp3',
    'yourock-fa.mp3',
    'ohyeah-fa.mp3',
    'alright-fa.mp3',
    'good-job-fa.mp3',
    'way-to-go-fa.mp3',
    'thats-it-fa.mp3',
    'great-fa.mp3',
    'nice-fa.mp3'
  ],
  mt: ['congratulations-mt.mp3', 'greatjob-mt.mp3', 'youdidit-mt.mp3'],
  ft: ['congratulations-ft.mp3', 'greatjob-ft.mp3', 'youdidit-ft.mp3']
};
